import { useEffect, useState } from "react"
import Overlay from "../../Componentes/Overlay"
import Modal from "../../Componentes/Utils/Modal"
import Tabela from "../../Componentes/Utils/Tabela"
import { useModal } from "../../contexts/ModalContext"
import axios from "axios"
import styled from "styled-components"

const TableCell = styled.td`
    color: black;
    text-align: ${(props) => {
        if (props.align === "left") return "left !important";
        if (props.align === "center") return "center !important";
        if (props.align === "right") return "right !important";
        return "left !important";
    }};
`
const StatusIcon = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${(props) => {
        if (props.status === 'ATIVO') return "#00b809";
        if (props.status === 'DESLIGADO') return "#a51a1a";
        return "#000"
    }};
    margin-left: 10px;
`
const Titulo = styled.h2`
    margin: 0 0 15px 5px;
    color: #333;
`

const ModalRepAloj = ({ quarto }) => {

    const { closeModal } = useModal();

    const [loading, setLoading] = useState(true);

    const [alojados, setAlojados] = useState([]);

    useEffect(() => {

        const fetchAlojados = async () => {
            setLoading(true);

            try {
                const { data } = await axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Republicas/GetAlojados/index.php?id=${quarto.identifier}`);
                setAlojados(data);
            } catch (e) {
                console.log(e)
            } finally {
                setLoading(false);
            }
        }

        fetchAlojados();

    }, [quarto])

    return (
        <>
            <Overlay state={true} >
                <Modal size="lg" header={true} close={closeModal} >
                    <Titulo>Alojados no quarto: {quarto.quarto_name}</Titulo>
                    <Tabela loading={loading} >
                        <thead>
                            <tr>
                                <th></th>
                                <th>MATRICULA</th>
                                <th>NOME</th>
                                <th>FUNÇÃO</th>
                                <th>ENCARREGADO</th>
                            </tr>
                        </thead>
                        <tbody>
                            {alojados.length === 0 ? (
                                <tr>
                                    <TableCell align="center" colSpan={5} >Nenhum alojado encontrado.</TableCell>
                                </tr>
                            ) : alojados.map((obj) => (
                                <tr key={obj.matricula} >
                                    <TableCell align="center" ><StatusIcon status={obj.status} /></TableCell>
                                    <TableCell>{obj.matricula}</TableCell>
                                    <TableCell>{obj.nome}</TableCell>
                                    <TableCell>{obj.funcao}</TableCell>
                                    <TableCell>{obj.lider_nome}</TableCell>
                                </tr>
                            ))}
                        </tbody>
                    </Tabela>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalRepAloj;